<div *ngIf="shouldShowBanner" class="trial-banner" style="background:#ffcc00;color:#333;text-align:center;padding:8px;font-weight:bold;">
  {{trialBanner}}
  <a *ngIf="accountStatus === 'ACTIVE' && daysUntilExpiry !== null && daysUntilExpiry <= 7" routerLink="/pago" style="margin-left:12px;color:#0d47a1;text-decoration:underline;font-weight:bold;">Renovar</a>
</div>
<ngx-spinner
  bdOpacity = 0.9
  bdColor = "#eee"
  size = "medium"
  color = "#e7403f"
  type = "line-scale"
></ngx-spinner>
<router-outlet></router-outlet>



// WEBPACK FOOTER //
// ./src/app/app.component.html